import * as Sentry from "@sentry/react";

const LOCAL_ENVIRONMENT = "LOCAL";

export const initSentry = () => {
    
    if (process.env.REACT_APP_ENVIRONMENT === LOCAL_ENVIRONMENT) {
        return;
    }
    
    const vegasGraphqlEndpoint = process.env.REACT_APP_VEGAS_GRAPHQL_ENDPOINT;
    const escapedGraphqlEndpoint = new RegExp(`^${vegasGraphqlEndpoint.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`);
    
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DATA_SOURCE_NAME,
        environment: process.env.REACT_APP_ENVIRONMENT,
        
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        
        tracesSampleRate: process.env.REACT_APP_SENTRY_TRACING_RATIO,

        tracePropagationTargets: [ "localhost", escapedGraphqlEndpoint ],

        // Session Replay
        replaysSessionSampleRate: process.env.REACT_APP_SENTRY_SESSION_SAMPLE_RATIO,
        replaysOnErrorSampleRate: process.env.REACT_APP_SENTRY_ERROR_SAMPLE_RATIO,
    });
}